import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { checkBuildVersion, hardRefresh } from 'libs/core/src/lib/utils/check-build-version';

@Component({
  selector: 'ic-update-toast',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (show()) {
      <div class="ic-update-toast">
        <span>A new version is available.</span>
        <button class="ic-update-toast__btn" (click)="update()">Update</button>
      </div>
    }
  `,
  styles: [`
    .ic-update-toast {
      position: fixed;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10000;
      background: var(--primary-color);
      color: #fff;
      padding: 12px 24px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      gap: 12px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      font-size: 14px;
    }
    .ic-update-toast__btn {
      background: #fff;
      color: var(--primary-color);
      border: none;
      border-radius: 4px;
      padding: 4px 12px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
    }
    .ic-update-toast__btn:hover {
      opacity: 0.85;
    }
  `],
})
export class IcUpdateToastComponent {
  show = signal(false);

  constructor(@Inject(DOCUMENT) private document: Document) {
    checkBuildVersion(this.document, () => this.show.set(true));
  }

  update(): void {
    this.show.set(false);
    const win = this.document.defaultView;
    if (win) hardRefresh(win);
  }
}
